export default "__VITE_ASSET__tHv6r2yB__"